// extracted by mini-css-extract-plugin
module.exports = {"StudentListContainer":"StudentList_StudentListContainer__1MZpg","StudentList":"StudentList_StudentList__3z_Fa"};